export const URL_PREFIX_DEV = 'http://core.crdev.dk'
export const URL_PREFIX = process.env.VUE_APP_CORE_URL
export const URL_ECHO = process.env.VUE_APP_URL_ECHO ? process.env.VUE_APP_URL_ECHO : process.env.VUE_APP_CORE_URL

export const ALL = { title: 'Low level', val: 0 }
export const PCN = { title: 'PCN', val: 10 }
export const SUPPORT = { title: 'Support', val: 20 }
export const ECONOMY = { title: 'Økonomi', val: 25 }
export const ADMIN = { title: 'Admin', val: 30 }
export const SUPERUSER = { title: 'Superuser', val: 90 }

export const ROLES = [
    ALL, PCN, SUPPORT, ECONOMY, ADMIN, SUPERUSER,
]
